import { List, ListItemButton, ListItemText, Collapse } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { FC, ReactNode } from 'react';
import ListItem from './ListItem';
import { formatForRoute } from '../utils';
import { Section } from '../FileStructure';

interface SectionState {
  [section: string]: boolean;
}

interface CollapsibleItemProps {
  section: Section;
  sectionState: SectionState;
  toggleSection: (section: string) => void;
  children?: ReactNode;
}

const CollapsibleItem: FC<CollapsibleItemProps> = ({ section, sectionState, toggleSection }) => {
  const { pathname } = useLocation();

  const splitPath = pathname.split("/");
  const sectionPath = splitPath.slice(-2).join("/");

  return (
    <>
      <ListItem section={section} sectionState={sectionState} toggleSection={toggleSection} hasSubsections={true} />
      <Collapse in={sectionState[section.title]} timeout="auto" unmountOnExit>
        <List disablePadding>
          {section.subsections.map((subsection, index) => (
            subsection.title !== "Introduction" && (
              subsection.subsections.length === 0 ?
                <li key={index}>
                  <Link
                    className="route-links"
                    to={`${section.url ? section.url : formatForRoute(section.title)}/${subsection.url ? subsection.url : formatForRoute(subsection.title)}`}
                  >
                    <ListItemButton
                      sx={{ pl: 4 }}
                      selected={sectionPath === `${section.url}/${subsection.url}`}
                    >
                      <ListItemText primary={`${subsection.index} ${subsection.title}`} />
                    </ListItemButton>
                  </Link>
                </li> :
                //  handle third level subsections 
                <div key={index}>
                  <List>
                    <ListItem section={section} sectionState={sectionState} toggleSection={toggleSection} hasSubsections={true} padding={4} subsection={subsection} />
                  </List>
                  <Collapse in={sectionState[`${section.title}/${subsection.title}`]} timeout="auto" unmountOnExit>
                    <List disablePadding>
                      {subsection.subsections.map((subsubsection, index) => (
                        subsubsection.title !== "Introduction" &&
                        <Link
                          key={index}
                          className="route-links"
                          to={`${section.url}/${subsubsection.url}`}
                        >
                          <ListItemButton
                            sx={{ pl: 6 }}
                            selected={
                              sectionPath === `${section.url}/${subsubsection.url}`
                            }
                          >
                            <ListItemText primary={`${subsubsection.index} ${subsubsection.title}`} />
                          </ListItemButton>
                        </Link>
                      ))}
                    </List>
                  </Collapse>
                </div>
            )
          ))}
        </List>
      </Collapse>
    </>
  );
};
export default CollapsibleItem;
